import React from 'react';
import { ValidatorComponent } from 'react-form-validator-core';

export class TextValidator extends ValidatorComponent {

    render() {
        const { errorMessages, validators, requiredError, validatorListener, ...rest } = this.props;

        return (
            <div>
                <input autoComplete="off" autoCorrect="off"
                    {...rest}
                    ref={(r) => { this.input = r; }}
                />
                {this.errorText()}
            </div>
        );
    }

    errorText() {
        const { isValid } = this.state;

        if (isValid) {
            return null;
        }

        return (
            <div className='error'>
                {this.getErrorMessage()}
            </div>
        );
    }
}

export default TextValidator;